import { NgClass } from '@angular/common';
import { ModalDialog, ModalService } from './modal.service';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DialogModule, DialogComponent as SyncfusionDialogComponent } from '@syncfusion/ej2-angular-popups';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    imports: [NgClass, DialogModule, TranslateModule]
})
export class ModalComponent implements OnInit{

  @ViewChild('dialog') dialog: SyncfusionDialogComponent;

  public modalDialog: ModalDialog;

  constructor(public modalService: ModalService, private cdr: ChangeDetectorRef) { }

  public ngOnInit(): void {
    this.modalService.dialogSubject.subscribe((modalDialog) => {
      const actualDialog = this.modalDialog;
      this.modalDialog = modalDialog;
      if (!modalDialog) {
        this.modalDialog = null;
        this.hideDialog();
      } else {
        this.modalDialog = modalDialog;
        this.showDialog();
        if (actualDialog) {
          this.cdr.detectChanges();
        }
      }
    });
  }

  public okClicked(): void {
    this.hideDialog();
    this.modalDialog.onOkSubject.next(null);
  }

  public cancelClicked(): void {
    this.hideDialog();
    this.modalDialog.onCancelSubject.next(null);
  }

  public onClose(eventArgs): void {
    if (eventArgs.isInteracted) {
      this.modalDialog.onCancelSubject.next(null);
    }
  }

  private hideDialog(): void {
    this.dialog.hide();
    this.dialog.zIndex = 1000;
  }

  private showDialog(): void {
    this.dialog.zIndex = 200000;
    this.dialog.show();
  }
}
